import {
	Component,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
} from "@angular/core";
import { ButtonThemeState } from "app/shared";

@Component({
    selector: "secondary-button",
    templateUrl: "./secondary-button.component.html",
    styleUrls: ["./secondary-button.component.scss"],
    standalone: false
})
export class SecondaryButtonComponent {
	@Input()
	busy = false;
	@Input()
	spinnerColor = "primary";
	@Input()
	contentPadding = 20;
	@Input() width?: string;
	@Input() set theme(theme: ButtonThemeState) {
		this._theme = this.setThemeColor(theme);
	}

	@ViewChild("button", { static: true })
	button: ElementRef;
	@Input() color;
	@Input() height = 40;
	@Input() radius = 3;
	@Input() iconImage: string;
	@Input() after = false;
	@Input() disabled = false;
	_theme = "white-theme";
	@Output() clicked = new EventEmitter();

	public shadowHeight = 3;

	constructor() {}

	public buttonClicked(event: Event): void {
		event.stopPropagation();
		this.clicked.emit(event);
	}

	private setThemeColor(theme): string {
		switch (theme) {
			case ButtonThemeState.PURPLE:
				return "purple-theme";

			case ButtonThemeState.GREEN:
				return "green-theme";

			default:
				return "white-theme";
		}
	}
}
